/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface IncustControllersClientClientReferralProgramInvitationRequestApiModel {
  /**
   * action type
   */
  action: IncustControllersClientClientReferralProgramInvitationRequestApiModelActionEnum;
}
export enum IncustControllersClientClientReferralProgramInvitationRequestApiModelActionEnum {
  Accept = 'accept',
  Reject = 'reject'
}
